import { Environment } from '@ftr/ui-core'

export const environment: Environment = {
  production: true,
  debugLogging: false,
}
